// TODO: add in dynamic dictionary for textDictionary and ctaModalDictionary
import "./index.scss";
import { CtaListProps } from "./types";
import {
  getAlignItemsClassNames,
  getJustifyContentClassNames,
} from "utilities/commonPropTypes/flex";
import React from "react";
import classNames from "classnames";

const CtaList = ({
  children,
  alignItems,
  justifyContent,
  forceSingleRow = false,
}: CtaListProps) => {
  const CtaListWrapClasses = classNames(
    "CtaList__wrap",
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
    {
      "CtaList__wrap--scroll-mobile":
        Array.isArray(children) && children.length > 2 && !forceSingleRow,
      "CtaList__wrap--single-row": forceSingleRow,
    },
  );

  return (
    <div className="CtaList">
      <div className={CtaListWrapClasses} data-testid="ctaWrapper">
        {Array.isArray(children) &&
          children.map((child) => {
            return (
              <div className="CtaList__item" key={child.props.id}>
                {child}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CtaList;
